import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["showTooltip", "tooltipArrow", "tooltipDescription", "tooltipLabel", "tooltipMaxWidth", "tooltipPlacement", "tooltipProps", "tooltipVariant", "tooltipWidth"];
import React, { forwardRef } from 'react';
import { BadgeBase } from './BadgeBase';
import { Tooltip } from '../Tooltip';

/**
 * UI component that represent an input, attribute or action -
 * It allows users to enter information, make selections, filter content, or trigger actions.
 * Uses the MUI Chip component internally.
 * Mui documentation link - https://mui.com/material-ui/react-chip/
 */
import { jsx as _jsx } from "react/jsx-runtime";
export var Badge = /*#__PURE__*/forwardRef(function Button(props, ref) {
  var _props$showTooltip = props.showTooltip,
    showTooltip = _props$showTooltip === void 0 ? false : _props$showTooltip,
    tooltipArrow = props.tooltipArrow,
    tooltipDescription = props.tooltipDescription,
    tooltipLabel = props.tooltipLabel,
    tooltipMaxWidth = props.tooltipMaxWidth,
    tooltipPlacement = props.tooltipPlacement,
    tooltipProps = props.tooltipProps,
    tooltipVariant = props.tooltipVariant,
    tooltipWidth = props.tooltipWidth,
    others = _objectWithoutProperties(props, _excluded);
  return showTooltip ? /*#__PURE__*/_jsx(Tooltip, _extends({
    arrow: tooltipArrow,
    description: tooltipDescription,
    label: tooltipLabel,
    maxWidth: tooltipMaxWidth,
    placement: tooltipPlacement,
    variant: tooltipVariant,
    width: tooltipWidth
  }, tooltipProps, {
    children: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(BadgeBase, _extends({
        ref: ref
      }, others))
    })
  })) : /*#__PURE__*/_jsx(BadgeBase, _extends({
    ref: ref
  }, others));
});